import "./Checkbox.css"

interface CheckboxProps {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  showCheckbox?: boolean
}

export default function PsychologySessionsCheckbox({
  label,
  checked,
  showCheckbox = true,
  onChange
}: CheckboxProps) {
  return (
    <label
      htmlFor="psychology-sessions-checkbox-container"
      className="checkbox-container bf-checkbox"
    >
      {showCheckbox ? (
        <>
          <input
            type="checkbox"
            id="psychology-sessions-checkbox-container"
            checked={checked}
            onChange={event => onChange(event.target.checked)}
            className="checkbox-input"
          />
          <span className="checkbox-custom"></span>
        </>
      ) : null}
      <span className="checkbox-label">{label}</span>
    </label>
  )
}
